export default __webpack_public_path__ + "static/media/img_block_2.b8db186f.svg";